import { WithdrawalControllerSubmitMethod } from '../methods/withdrawal-controller/submit.method';

export class WithdrawalController {
  public readonly submit = new WithdrawalControllerSubmitMethod();
}
